// extracted by mini-css-extract-plugin
export default {"root":"AdministrationInvitations_root__Zx3tk","main":"AdministrationInvitations_main__zk9nF"};